module.exports = __webpack_public_path__ + "static/img/coupon3.200325a3.png";